import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UserStatus } from 'app/scripts/components/moderation-v2/users/UserStatus';

class UserListController extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    spotId: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    resetSearch: PropTypes.func.isRequired,
    addUser: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired,
    isUserOnList: PropTypes.bool,
    type: PropTypes.string
  };

  static displayName = 'UserListController';

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  onAdd = () => {
    var { spotId, userId, resetSearch, addUser, user } = this.props;
    resetSearch();
    addUser({ spotId, userId, user });
  };

  onRemove = () => {
    const { spotId, userId, resetSearch, removeUser, user } = this.props;
    resetSearch();
    removeUser({ spotId, userId, user });
  };

  render() {
    const { isUserOnList, type, user } = this.props;
    const statusComponent = getUserStatusComponent(type, user);

    if (statusComponent) {
      return statusComponent;
    }

    return (
      <div className="buttons">
        {isUserOnList ? (
          <span className="moderator-button" onClick={this.onRemove}>
            Remove
          </span>
        ) : (
          <span className="moderator-button" onClick={this.onAdd}>
            Add
          </span>
        )}
      </div>
    );
  }
}

export default UserListController;

function getUserStatusComponent(type, user) {
  if (type === 'blacklist' && user.isWhitelisted) {
    return <UserStatus allowed={true} />;
  }

  if (type === 'whitelist' && user.isBlacklisted) {
    return <UserStatus allowed={false} />;
  }

  return null;
}
